import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance27czzec4fvnke as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import { Phases_getInstance2qxbzj50paf3c as Phases_getInstance_0 } from '../statement/HttpResponsePipeline.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  SetupRequest_instancezsckteg7b0pk as SetupRequest_instance,
  Send_instance3jwyi367vhqvc as Send_instance,
} from './api/CommonHooks.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  get_coroutineContext1djaai1ellg0c as get_coroutineContext,
  HttpRequest3fsc4149kgwfg as HttpRequest,
} from '../request/HttpRequest.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
import { PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return LOGGER;
}
var LOGGER;
function get_HttpCallValidator() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return HttpCallValidator;
}
var HttpCallValidator;
function get_ExpectSuccessAttributeKey() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return ExpectSuccessAttributeKey;
}
var ExpectSuccessAttributeKey;
var HttpCallValidatorConfigClass;
function HttpCallValidatorConfig() {
  if (HttpCallValidatorConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.d5n_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.e5n_1 = ArrayList().p2();
        this.f5n_1 = true;
      }
      g5n(block) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.d5n_1.i2(block);
      }
    }
    initMetadataForClass($, 'HttpCallValidatorConfig', HttpCallValidatorConfig);
    HttpCallValidatorConfigClass = $;
  }
  return HttpCallValidatorConfigClass;
}
function HttpResponseValidator(_this__u8e3s4, block) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  _this__u8e3s4.g5i(get_HttpCallValidator(), block);
}
var ExceptionHandlerWrapperClass;
function ExceptionHandlerWrapper() {
  if (ExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ExceptionHandlerWrapper');
    ExceptionHandlerWrapperClass = $;
  }
  return ExceptionHandlerWrapperClass;
}
var RequestExceptionHandlerWrapperClass;
function RequestExceptionHandlerWrapper() {
  if (RequestExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RequestExceptionHandlerWrapper');
    RequestExceptionHandlerWrapperClass = $;
  }
  return RequestExceptionHandlerWrapperClass;
}
function RequestError$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    try {
      yield* $this$intercept.y4r($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        var error = yield* $handler(HttpRequest_0($this$intercept.v4s_1), cause, $completion);
        if (!(error == null))
          throw error;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 2);
}
var RequestErrorClass;
function RequestError() {
  if (RequestErrorClass === VOID) {
    class $ {
      t5o(client, handler) {
        var tmp = Phases_getInstance().f5m_1;
        client.d5g_1.z4s(tmp, RequestError$install$slambda(handler));
      }
      k5m(client, handler) {
        return this.t5o(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RequestError');
    RequestErrorClass = $;
  }
  return RequestErrorClass;
}
var RequestError_instance;
function RequestError_getInstance() {
  return RequestError_instance;
}
function ReceiveError$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    try {
      yield* $this$intercept.y4r($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        var error = yield* $handler($this$intercept.v4s_1.o5i(), cause, $completion);
        if (!(error == null))
          throw error;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 2);
}
var ReceiveErrorClass;
function ReceiveError() {
  if (ReceiveErrorClass === VOID) {
    class $ {
      t5o(client, handler) {
        var BeforeReceive = new (PipelinePhase())('BeforeReceive');
        client.e5g_1.y4s(Phases_getInstance_0().l5h_1, BeforeReceive);
        client.e5g_1.z4s(BeforeReceive, ReceiveError$install$slambda(handler));
      }
      k5m(client, handler) {
        return this.t5o(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ReceiveError');
    ReceiveErrorClass = $;
  }
  return ReceiveErrorClass;
}
var ReceiveError_instance;
function ReceiveError_getInstance() {
  return ReceiveError_instance;
}
function HttpRequest_0(builder) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return new (HttpRequest$1())(builder);
}
function HttpCallValidatorConfig$_init_$ref_m1o2g9() {
  return constructCallableReference(() => new (HttpCallValidatorConfig())(), 0, 0, 216, '<init>');
}
function HttpCallValidator$lambda($this$createClientPlugin) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  var responseValidators = reversed($this$createClientPlugin.r5m_1.d5n_1);
  var callExceptionHandlers = reversed($this$createClientPlugin.r5m_1.e5n_1);
  var expectSuccess = $this$createClientPlugin.r5m_1.f5n_1;
  var tmp = SetupRequest_instance;
  $this$createClientPlugin.u5m(tmp, HttpCallValidator$lambda$slambda(expectSuccess));
  var tmp_0 = Send_instance;
  $this$createClientPlugin.u5m(tmp_0, HttpCallValidator$lambda$slambda_0(responseValidators));
  var tmp_1 = RequestError_instance;
  $this$createClientPlugin.u5m(tmp_1, HttpCallValidator$lambda$slambda_1(callExceptionHandlers));
  var tmp_2 = ReceiveError_instance;
  $this$createClientPlugin.u5m(tmp_2, HttpCallValidator$lambda$slambda_2(callExceptionHandlers));
  return Unit_instance;
}
function *invoke$validateResponse(responseValidators, response, $completion) {
  get_LOGGER().z4t('Validating response for request ' + response.v5i().o5i().x5i().toString());
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = responseValidators.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    yield* element(response, $completion);
  }
  return Unit_instance;
}
function *invoke$processException(callExceptionHandlers, cause, request, $completion) {
  get_LOGGER().z4t('Processing exception ' + cause.toString() + ' for request ' + request.x5i().toString());
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = callExceptionHandlers.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof ExceptionHandlerWrapper())
      yield* element.v5o_1(cause, $completion);
    else {
      if (element instanceof RequestExceptionHandlerWrapper())
        yield* element.u5o_1(cause, request, $completion);
      else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
function HttpCallValidator$lambda$slambda($expectSuccess) {
  return constructCallableReference(function *(request, $completion) {
    var tmp = get_ExpectSuccessAttributeKey();
    request.c5i_1.n4n(tmp, () => $expectSuccess);
    return Unit_instance;
  }, 1);
}
function HttpCallValidator$lambda$slambda_0($responseValidators) {
  return constructCallableReference(function *($this$on, request, $completion) {
    var call = yield* $this$on.y5o(request, $completion);
    yield* /*#__NOINLINE__*/invoke$validateResponse($responseValidators, call.q5g(), $completion);
    return call;
  }, 2);
}
function HttpCallValidator$lambda$slambda_1($callExceptionHandlers) {
  return constructCallableReference(function *(request, cause, $completion) {
    var unwrappedCause = unwrapCancellationException(cause);
    yield* /*#__NOINLINE__*/invoke$processException($callExceptionHandlers, unwrappedCause, request, $completion);
    return unwrappedCause;
  }, 2);
}
function HttpCallValidator$lambda$slambda_2($callExceptionHandlers) {
  return constructCallableReference(function *(request, cause, $completion) {
    var unwrappedCause = unwrapCancellationException(cause);
    yield* /*#__NOINLINE__*/invoke$processException($callExceptionHandlers, unwrappedCause, request, $completion);
    return unwrappedCause;
  }, 2);
}
var HttpRequest$1Class;
function HttpRequest$1() {
  if (HttpRequest$1Class === VOID) {
    class $ {
      constructor($builder) {
        this.d5p_1 = $builder;
        this.z5o_1 = $builder.y5h_1;
        this.a5p_1 = $builder.x5h_1.i37();
        this.b5p_1 = $builder.c5i_1;
        this.c5p_1 = $builder.z5h_1.i37();
      }
      v5i() {
        // Inline function 'kotlin.error' call
        var message = 'Call is not initialized';
        throw IllegalStateException().o(toString(message));
      }
      w5i() {
        return this.z5o_1;
      }
      x5i() {
        return this.a5p_1;
      }
      p5i() {
        return this.b5p_1;
      }
      v51() {
        return this.c5p_1;
      }
      z2n() {
        var tmp = this.d5p_1.a5i_1;
        var tmp0_elvis_lhs = tmp instanceof OutgoingContent() ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'Content was not transformed to OutgoingContent yet. Current body is ' + toString(this.d5p_1.a5i_1);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
    }
    protoOf($).bw = get_coroutineContext;
    initMetadataForClass($, VOID, VOID, VOID, [HttpRequest()]);
    HttpRequest$1Class = $;
  }
  return HttpRequest$1Class;
}
var properties_initialized_HttpCallValidator_kt_xrx49w;
function _init_properties_HttpCallValidator_kt__r6yh2y() {
  if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
    properties_initialized_HttpCallValidator_kt_xrx49w = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
    var tmp = HttpCallValidatorConfig$_init_$ref_m1o2g9();
    HttpCallValidator = createClientPlugin('HttpResponseValidator', tmp, HttpCallValidator$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ExpectSuccessAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().uf();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().uf(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
    ExpectSuccessAttributeKey = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: init
RequestError_instance = new (RequestError())();
ReceiveError_instance = new (ReceiveError())();
//endregion
//region block: exports
export {
  get_ExpectSuccessAttributeKey as get_ExpectSuccessAttributeKey20jj5fup38v1g,
  get_HttpCallValidator as get_HttpCallValidator3iji36qylbtbr,
  HttpResponseValidator as HttpResponseValidator2d6ie1tmzg8fi,
};
//endregion

//# sourceMappingURL=HttpCallValidator.mjs.map
